export default function hotButtons() {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;

  const wrapContainerClass = 'cards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: 'all',
    showDescription: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: true,
    moreButton: false,
    maxItemsVisible: 3,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);

      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
          </div>`);

      if (!URL) {
        $cardItem.addClass('empty-card').removeAttr('href');
      }
    });
  }
}
